import React from 'react';
import {Link,NavLink} from 'react-router-dom';
import Modal from './Modal'


class Projects extends React.Component{

	state={toggle:false,data:''};

	onProclick=(event)=>{
		var data=event.target.textContent
		this.setState({toggle:true,data:data});
	}


	onClose=(toggle)=>{
      this.setState({toggle:toggle});
	}

	render(){

		if(this.state.toggle){
			return(
				<Modal onClose={this.onClose} data={this.state.data}/>
				)
		}else{

		return(
			<div>
				<nav className="ui raised very padded segment">
					<span style={{fontSize:'25px'}} ><Link to="/">Asfak Ahmed</Link></span>
					<div className="ui right floated header">
					<Link to="/About"><button className="ui button">About</button></Link>
					<NavLink to="/Projects"><button className="ui yellow button">Projects</button></NavLink>
					<NavLink to="/Contact"><button className="ui button">Contact</button></NavLink>
					</div>
				</nav>	
			    
				<div>	
				    <div className="ui raised very padded text container segment"style={{marginTop:'80px'}}>
						<h3 className='ui header'>My projects</h3>
						<p style={{cursor:'pointer', color:'white',textDecoration : 'underline', background :'#95a5a6'}} className='ui text segment' onClick={this.onProclick} >Project 1</p>
						<p style={{cursor:'pointer', color:'white',textDecoration : 'underline', background :'#95a5a6'}} className='ui text segment' onClick={this.onProclick} >Project 2</p>
						<p style={{cursor:'pointer', color:'white',textDecoration : 'underline', background :'#95a5a6'}} className='ui text segment' onClick={this.onProclick} >Project 3</p>
						<p style={{cursor:'pointer', color:'white',textDecoration : 'underline', background :'#95a5a6'}} className='ui text segment' onClick={this.onProclick} >Project 4</p>
						<p style={{cursor:'pointer', color:'white',textDecoration : 'underline', background :'#95a5a6'}} className='ui text segment' onClick={this.onProclick} >Project 5</p>
					</div>
				</div>
			</div>		
		)
	}
}
}
export default Projects;